import React, { useState } from "react";
import * as styles from "./Header.module.css";
import { DesktopNav } from "./DesktopNav";
import { MobileNav } from "./MobileNav";
import { ImageItem } from "@kontent-ai/gatsby-components/dist/image-element";
import { LoginDrawer } from "./LoginDrawer";
import { NavigationItem } from "../../../types";
import { LoginForm } from "../../blocks/LoginForm/LoginForm";

interface Props {
  id: string;
  logo: ImageItem;
  style: "light" | "dark" | "transparent";
  navigation: NavigationItem[];
  secondaryNavigation: NavigationItem[];
  forms: LoginForm[];
}

export const Header: React.FC<Props> = ({
  id,
  logo,
  style = "light",
  navigation,
  secondaryNavigation,
  forms,
}) => {
  const headerClass = `${styles.header} ${styles[style]}`;
  const [loginOpen, setLoginOpen] = useState(false);

  return (
    <header
      id="site-header"
      className={headerClass}
      data-kontent-element-codename="header"
      data-kontent-item-id={id}
    >
      <div className={styles.headerContainer}>
        <div className={styles.logo}>
          <a href="/">
            {logo?.url && (
              <img
                className={styles.logo}
                src={logo.url}
                alt={logo?.description}
              />
            )}
          </a>
        </div>
        {navigation && (
          <>
            <DesktopNav
              navigation={navigation}
              secondaryNavigation={secondaryNavigation}
              setLoginOpen={setLoginOpen}
            />
            <MobileNav
              navigation={navigation}
              secondaryNavigation={secondaryNavigation}
              setLoginOpen={setLoginOpen}
            />
          </>
        )}
        {forms && (
          <LoginDrawer
            open={loginOpen}
            setLoginOpen={setLoginOpen}
            forms={forms}
          />
        )}
      </div>
    </header>
  );
};
